import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import type { RecommendedGroup } from 'src/app/pages/starterDashboardV2/shared/types';

import type { RecommendedGroupWithPlatform } from '../../../../hooks/useSharingTools/types';
import { SharingToolsCardWrapperVariant2 } from '../../../SharingToolsCardWrapper/variant2';
import { RecommendedGroupsCardsContainer } from '../RecommendedGroupCardsContainer';
import { RecommendedGroupsCardLoadingVariant2 } from '../RecommendedGroupsCardLoading/variant2';

type RecommendedGroupsCardPreviewVariant2Props = Readonly<{
	recommendedGroups: {
		isLoading: boolean;
		groups: readonly RecommendedGroupWithPlatform[];
	};
	primaryAction?: () => void;
	fallbackPrimaryAction?: () => void;
	onFacebookGroupClick?: (group: RecommendedGroup) => void;
	onRedditGroupClick?: (group: RecommendedGroup) => void;
}>;

export const RecommendedGroupsCardPreviewVariant2: React.FC<RecommendedGroupsCardPreviewVariant2Props> = ({
	recommendedGroups,
	primaryAction = () => {},
	fallbackPrimaryAction = () => {},
	onFacebookGroupClick,
	onRedditGroupClick,
}) => {
	const { isLoading, groups } = recommendedGroups;

	const preview =
		isLoading || groups.length === 0 ? (
			<RecommendedGroupsCardLoadingVariant2 />
		) : (
			<RecommendedGroupsCardsContainer
				groups={groups}
				onFacebookGroupClick={onFacebookGroupClick}
				onRedditGroupClick={onRedditGroupClick}
			/>
		);

	const hasNoGroups = groups.length === 0 && !isLoading;
	const title = hasNoGroups
		? translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.recommended_groups.title_no_groups_variant2')
		: translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.recommended_groups.title_variant2');
	const description = hasNoGroups
		? translationKey(
				'corgi.petition.starter_dashboard_v2.sharing_tools.recommended_groups.description_no_groups_variant2',
			)
		: translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.recommended_groups.description_variant2');

	const primaryActionText = hasNoGroups
		? translationKey(
				'corgi.petition.starter_dashboard_v2.sharing_tools.recommended_groups.primary_action_text_no_groups',
			)
		: translationKey(
				'corgi.petition.starter_dashboard_v2.sharing_tools.recommended_groups.primary_action_text_variant2',
			);

	const ctaAction = hasNoGroups ? fallbackPrimaryAction : primaryAction;

	return (
		<SharingToolsCardWrapperVariant2
			Preview={preview}
			titleKey={title}
			descriptionKey={description}
			primaryActionTextKey={primaryActionText}
			primaryActionOnClick={ctaAction}
		/>
	);
};
